import { AppWindow } from '../../definitions/AppWindow';

declare let window: AppWindow;

export function getLocation() {
  return window.location;
}

export function getLocationHref() {
  return window.location.href;
}

export function getCwContext() {
  return window.cwContext;
}

export function getDocumentElement() {
  return document.documentElement;
}
